import React, { Component } from 'react';
import '../App.css';
import TelevisionBreakpoint from "../components/responsive_utilities/television_breakpoint";
import DesktopBreakpoint from "../components/responsive_utilities/desktop_breakpoint";
import TabletBreakpoint from "../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../components/responsive_utilities/phone_breakpoint";
import Dimensions from 'react-dimensions';
import ReactPlayer from 'react-player';
const sancoLogo = 'https://firebasestorage.googleapis.com/v0/b/sancochero-51ea9.appspot.com/o/sancoLogoWhite.png?alt=media&token=67607409-da15-41c6-8fa9-c9881c696085';

var firebase = require('firebase/app');
require('firebase/database');

class LiveFeed extends Component {
  
  constructor() {
    super();
    this.state = {
      currentVideo: 'https://stream.mux.com/200W34plu5OMS1ZGxv02v00jZpwv3gGbEzz.m3u8',
      width: 0,
      height: 0
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);  
		this.baseRef = firebase.database().ref('/');
  }
  
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }
	
	reloadPage() {
    window.location.reload(true);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  
  render() {
    return (
      <div
        className='wrapper'
        width= {this.state.width}
        height= {this.state.height} >
			<TelevisionBreakpoint>
        <ReactPlayer 
          url={this.state.currentVideo}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {}}
          playing={this.state.vidPlaying} /> ? : null }
				</TelevisionBreakpoint>
				<DesktopBreakpoint>
        <ReactPlayer 
          url={this.state.currentVideo}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {}}
          playing={this.state.vidPlaying} /> ? : null }
				</DesktopBreakpoint>
				<TabletBreakpoint>
        <ReactPlayer 
          url={this.state.currentVideo}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {}}
          playing={this.state.vidPlaying} /> ? : null }
				</TabletBreakpoint>
				<PhoneBreakpoint>
        <ReactPlayer 
          url={this.state.currentVideo}
          controls={true}
          width={this.state.width}
          height={this.state.height}
          className='player'
          volume={.5}
          muted={false}
          playsinline={true}
          onEnded={() => {}}
          playing={this.state.vidPlaying} /> ? : null }
				</PhoneBreakpoint>
      </div>
    );
  }
}

export default LiveFeed;



// WEBPACK FOOTER //
// ./src/pages/LiveFeed.js